export default {
  instagramURL: 'https://www.instagram.com/atelier.milky/',
  facebookURL: 'https://www.facebook.com/ateliermilky/',
  pinterestURL: 'https://www.pinterest.com/ateliermilky/',
  twitterURL: '',
  twitterUsername: '' // without the @
}
